export function createSvgFromString(text) {
  return `<svg xmlns="http://www.w3.org/2000/svg" height="100" width="300"><text fill="black" font-family="Mr Dafoe"  font-style="italic" font-size="20" x="50%" y="55%" text-anchor="middle">${text}</text></svg>`
}
